module.exports = __webpack_public_path__ + "img/wangjingchuan.17c7c994.jpg";